import { render, staticRenderFns } from "./BingoInterface.vue?vue&type=template&id=2085e19a&scoped=true"
import script from "./BingoInterface.vue?vue&type=script&lang=js"
export * from "./BingoInterface.vue?vue&type=script&lang=js"
import style0 from "./BingoInterface.vue?vue&type=style&index=0&id=2085e19a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2085e19a",
  null
  
)

export default component.exports